import PropTypes from 'prop-types';
import React from 'react';
import { trackEvent } from 'helpers/Analytics';
import buildJobsListingCopy from 'containers/Projects/buildJobsListingCopy';
import styles from './JobsResultsHeader.module.scss';

const JobsResultsHeader = ({
  pageType,
  filterCount,
  role,
  selectedRoleName,
  country,
  city,
  auth,
  onBestMatchNavigate,
  bestMatch,
  filterSummary,
}) => {
  if (bestMatch) {
    return (
      <div className={styles.header} data-testid="jobs-results-header">
        <p className={styles.heading} data-testid="jobs-results-heading">
          <strong className={styles.filteredLabel}>Best match</strong> jobs
          found by Ari
        </p>
      </div>
    );
  }

  const { resultsLine } = buildJobsListingCopy({
    role: role || null,
    roleDisplayName: selectedRoleName || null,
    country,
    city,
  });

  // Split so "Try Best match" stays a tracked link.
  const bestMatchLabel = 'Try Best match';
  let prefix = resultsLine.endsWith(bestMatchLabel)
    ? resultsLine.slice(0, -bestMatchLabel.length)
    : `${resultsLine} · `;

  const isFiltered = filterCount > 0;
  if (isFiltered && prefix.startsWith('Latest')) {
    prefix = `latest${prefix.slice('Latest'.length)}`;
  }

  const handleBestMatch = (event) => {
    event.preventDefault();
    trackEvent('jobs-best-match-clicked', {
      source: 'heading',
      pageType,
      auth,
      filterCount,
    });
    if (onBestMatchNavigate) {
      onBestMatchNavigate();
    }
  };

  return (
    <div className={styles.header} data-testid="jobs-results-header">
      <p className={styles.heading} data-testid="jobs-results-heading">
        {isFiltered && (
          <strong
            className={styles.filteredLabel}
            data-testid="jobs-results-filtered"
          >
            Filtered
          </strong>
        )}
        {isFiltered ? ` ${prefix}` : prefix}
        <a
          href="/ari"
          className={styles.bestMatchLink}
          onClick={handleBestMatch}
          data-testid="jobs-best-match-heading"
        >
          {bestMatchLabel}
        </a>
      </p>
      {filterSummary.length > 0 && (
        <p className={styles.summary} data-testid="jobs-results-filter-summary">
          Also filtered by: {filterSummary.join(' · ')}
        </p>
      )}
    </div>
  );
};

JobsResultsHeader.propTypes = {
  pageType: PropTypes.oneOf(['jobs', 'role', 'country']).isRequired,
  filterCount: PropTypes.number,
  role: PropTypes.string,
  selectedRoleName: PropTypes.string,
  country: PropTypes.string,
  city: PropTypes.string,
  auth: PropTypes.oneOf(['guest', 'logged_in']).isRequired,
  onBestMatchNavigate: PropTypes.func,
  /** Ari is showing instead of the listing. */
  bestMatch: PropTypes.bool,
  /** Applied filters other than roles (getFilterSummary). */
  filterSummary: PropTypes.arrayOf(PropTypes.string),
};

JobsResultsHeader.defaultProps = {
  filterCount: 0,
  role: null,
  selectedRoleName: '',
  country: null,
  city: null,
  onBestMatchNavigate: undefined,
  bestMatch: false,
  filterSummary: [],
};

export default JobsResultsHeader;
